module.exports = __webpack_public_path__ + "assets/media/rectangle.f48af311.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/CustomMessage/rectangle.svg
// module id = 2113
// module chunks = 0